module.exports = __webpack_public_path__ + "assets/img/pingtaiyoushiCover3.db82fb1d.jpg";